import createClient, { Middleware } from 'openapi-fetch';

import type { paths } from '@/openapi/schema';
import { getAzureToken } from '@/request';

/**
 * Client that can be used to interact with the V2 (Kotlin) backend endpoints.
 */
export const backendClient = createClient<paths>({ baseUrl: '/service/v2' });

const authMiddleware: Middleware = {
  onRequest: async ({ request }) => {
    const token = await getAzureToken();
    if (token) {
      request.headers.set('Authorization', `Bearer ${token}`);
    } else {
      return undefined;
    }
    return request;
  },
};

backendClient.use(authMiddleware);
